import axios from 'axios'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import { DEFAULT_SELLER_NUMBER } from 'src/constants'

const url = '/api/getMulticurrencyPrices'

type CacheID = string

type CacheData = CacheID

const CACHE: Record<CacheData, MulticurrencyPrices[]> = {}

const getMulticurrencyPrices = async (
  setMulticurrencyPrices: Dispatch<SetStateAction<MulticurrencyPrices[] | []>>,
  sellerId: string,
  skuId: string
) => {
  const cacheID = `${sellerId}-${skuId}`

  if (CACHE[cacheID] !== undefined) {
    setMulticurrencyPrices(CACHE[cacheID])
  } else {
    await axios
      .get(url, {
        params: {
          skuId,
          sellerId,
        },
      })
      .then((response) => {
        CACHE[cacheID] = response.data
        setMulticurrencyPrices(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export const useGetMulticurrencyPrices = (sellerId: string, skuId: string) => {
  const [loading, setLoading] = useState(false)
  const [multicurrencyPrices, setMulticurrencyPrices] = useState<
    MulticurrencyPrices[] | []
  >([])

  useEffect(() => {
    if (sellerId === DEFAULT_SELLER_NUMBER) {
      return
    }

    setLoading(true)
    getMulticurrencyPrices(setMulticurrencyPrices, sellerId, skuId).then(() =>
      setLoading(false)
    )
  }, [sellerId, skuId])

  const lastIndex = multicurrencyPrices.length - 1

  const multicurrecySellingPrice =
    multicurrencyPrices[lastIndex]?.discountValue === 'NaN'
      ? Number(multicurrencyPrices[lastIndex]?.value)
      : Number(multicurrencyPrices[lastIndex]?.discountValue)

  const multicurrencyListPrice =
    multicurrencyPrices[lastIndex]?.discountValue === 'NaN'
      ? null
      : Number(multicurrencyPrices[lastIndex]?.value)

  return {
    multicurrecySellingPrice,
    multicurrencyListPrice,
    loading,
  }
}
